module.exports = __webpack_public_path__ + "static/media/lauka.32009bcb.ogg";